import {
	AnyRoute,
	createRootRoute,
	createRoute,
	createRouter,
} from '@tanstack/react-router';

import { basepath } from '@/constants';
import config from '@/config';

import { logOut } from '@/templates/basic/auth/Auth.hooks';

import Home from './home/Home';

import Issues from '@/views/issues/Issues';
import Issue from '@/views/issue/Issue';
import Drafts from '@/views/drafts/Drafts';
import { AUTH_KEY } from '@/views/home/auth/Authentication.hooks';
import { RootRouteComponent, NotFound } from '@/views/RootRoute';

import { Preview } from '@/components/preview/Preview';

import { Callback } from '@/templates/basic/callback/Callback';
import { Logout } from '@/templates/basic/auth/Logout';
import { Subscriptions } from '@/templates/basic/subscriptions/Subscriptions';
import { Success } from '@/templates/basic/subscriptions/success/Success';
import { issueSearchSchema } from '@/views/issue/Issue.hooks';

const onClickLogOut = localStorage.getItem(AUTH_KEY)
	? (url?: string): void => {
			console.log(`Click logout to the followin url: ${url}`);
			logOut(url || '/logout');
	  }
	: undefined;

/* Routes declaration */

const rootRoute = createRootRoute({
	component: RootRouteComponent,
});

const indexRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/',
	component: () => <Home onClickLogOut={onClickLogOut} />,
});

const issuesRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Issues,
	path: 'issues',
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: () => <Issue onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: () => <Issue onClickLogOut={onClickLogOut} />,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const previewRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Preview,
	path: 'preview/$id',
});

const subscriptionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Subscriptions,
	path: 'subscriptions',
});

const subscriptionsSuccessRoute = createRoute({
	getParentRoute: () => subscriptionsRoute,
	component: Success,
	path: 'success',
});

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Callback,
	path: 'callback',
});

const logoutRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Logout,
	path: 'logout',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: Drafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	issuesRoute,
	issueRoute,
	issueArticleRoute,
	previewRoute,
	subscriptionsRoute,
	subscriptionsSuccessRoute,
	callbackRoute,
	logoutRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
